import React from 'react';
import './LcdDisplay.css';

const LcdDisplay = ({ text }) => (
    <div className="lcd-display">
        <span className="lcd-label">Message:</span>
        <span className="lcd-text">{text || '—'}</span>
    </div>
);

export default LcdDisplay;
